import contains from './contains';
import values from './values';
export default (function (obj, value) { return contains(values(obj), value); });
//# sourceMappingURL=has-value.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/has-value.js
// module id = 480
// module chunks = 3